import { NgModule } from '@angular/core';

import { TiimePipesModule } from 'tiime-expert-utils';

import { DocumentsTableComponent } from '@modules/company/documents-and-editions/documents/documents-core/components/documents-table/documents-table.component';
import { RefreshButtonComponent } from '@modules/shared/components/refresh-button/refresh-button.component';
import { DocumentCategorySelectComponent } from '@modules/shared/selectors/document-category-select/document-category-select.component';
import { SharedModule } from '@modules/shared/shared.module';

import { AddFileFromDocumentsDialogComponent } from './add-file-from-documents-dialog.component';

@NgModule({
  declarations: [AddFileFromDocumentsDialogComponent],
  imports: [
    SharedModule,
    TiimePipesModule,
    RefreshButtonComponent,
    DocumentCategorySelectComponent,
    DocumentsTableComponent
  ]
})
export class AddFileFromDocumentsDialogModule {}
